import { HttpHandler, HttpClient, HttpHeaders } from '@angular/common/http';
import { tap, finalize } from 'rxjs/operators';
import { LoadingService } from './local/loading.service';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./local/loading.service";
export class HttpinterceptorService extends HttpClient {
    constructor(httpHandler, loadingService) {
        super(httpHandler);
        this.httpHandler = httpHandler;
        this.loadingService = loadingService;
    }
    getRequest(url, doNotShowLoader) {
        this.showLoader(doNotShowLoader);
        return super.get(url, this.getRequestOptions()).pipe(tap((response) => {
            this.onSubscribeSuccess(response);
        }, (error) => {
            this.onSubscribeError(error);
        })).pipe(finalize(() => {
            this.onFinally();
        }));
    }
    postRequest(url, body, doNotShowLoader) {
        this.showLoader(doNotShowLoader);
        return super.post(url, body, this.getRequestOptions()).pipe(tap((response) => {
            this.onSubscribeSuccess(response);
        }, (error) => {
            this.onSubscribeError(error);
        })).pipe(finalize(() => {
            this.onFinally();
        }));
    }
    putRequest(url, body, doNotShowLoader) {
        this.showLoader(doNotShowLoader);
        return super.put(url, body, this.getRequestOptions()).pipe(tap((response) => {
            this.onSubscribeSuccess(response);
        }, (error) => {
            this.onSubscribeError(error);
        })).pipe(finalize(() => {
            this.onFinally();
        }));
    }
    deleteRequest(url, doNotShowLoader) {
        this.showLoader(doNotShowLoader);
        return super.delete(url, this.getRequestOptions()).pipe(tap((response) => {
            this.onSubscribeSuccess(response);
        }, (error) => {
            this.onSubscribeError(error);
        })).pipe(finalize(() => {
            this.onFinally();
        }));
    }
    getRequestOptions() {
        let token = environment.authToken;
        let httpOptions = {
            headers: new HttpHeaders({})
        };
        if (token) {
            httpOptions.headers = httpOptions.headers.set('Authorization', token);
            httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json');
        }
        return httpOptions;
    }
    showLoader(doNotShowLoader) {
        if (!doNotShowLoader)
            this.loadingService.isLoading.next(true);
    }
    hideLoader() {
        this.loadingService.isLoading.next(false);
    }
    onFinally() {
        this.hideLoader();
    }
    onSubscribeError(error) {
        this.hideLoader();
    }
    onSubscribeSuccess(response) {
        this.hideLoader();
    }
}
HttpinterceptorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HttpinterceptorService_Factory() { return new HttpinterceptorService(i0.ɵɵinject(i1.HttpHandler), i0.ɵɵinject(i2.LoadingService)); }, token: HttpinterceptorService, providedIn: "root" });
